import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";

import ComparisonImpl from "~/components/Comparison";
import Wrapper from "~/components/SliceWrapper";

export type ComparisonProps = SliceComponentProps<Content.ComparisonSlice>;

const Comparison: FC<ComparisonProps> = ({ slice }) => {
  return (
    // @ts-expect-error — SliceWrapper is an untyped JS component
    <Wrapper
      cssClass="comparison-slice"
      data-analytics-component="comparison"
      slice={slice}
    >
      <ComparisonImpl slice={slice} />
    </Wrapper>
  );
};

export default Comparison;
